import { Reveal } from "./Reveal";
import { IMAGES, waLink } from "./data";
import { WhatsAppIcon } from "./WhatsAppIcon";

export default function Promise() {
  return (
    <section
      className="relative overflow-hidden py-24 lg:py-32"
      data-testid="service-promise-banner"
    >
      <img
        src={IMAGES.cardio}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-edge/90 mix-blend-multiply" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-transparent" />

      <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal>
          <p className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-white/80">
            Our Service Promise
          </p>
          <h2 className="max-w-4xl font-display text-4xl font-black uppercase leading-[0.95] tracking-tight text-white sm:text-6xl lg:text-7xl">
            When you buy from Lift Edge, <span className="text-outline">we stay with you.</span>
          </h2>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-white/85 sm:text-lg">
            We build your gym according to your budget — from planning the
            right equipment for your space to installation and after-sales
            support, we keep it simple, reliable and hassle-free.
          </p>
          <a
            href={waLink("Hi Lift Edge team, I'd like to speak to someone about my fitness equipment requirements.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="service-promise-cta-whatsapp"
            className="clip-corner-sm mt-10 inline-flex items-center gap-3 bg-white px-8 py-4 font-display text-lg font-bold uppercase tracking-wider text-ink transition-colors duration-200 hover:bg-ink hover:text-white"
          >
            <WhatsAppIcon className="h-5 w-5" />
            Speak to Our Team
          </a>
        </Reveal>
      </div>
    </section>
  );
}
